import type { PropsWithChildren, ReactNode } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';
import { Placeholder } from './internals/placeholder';
import styles from './address-placeholder.module.css';

interface AddressPlaceholderProps {
  addressType: 'merchant' | 'client';
}

export function AddressPlaceholder({
  addressType,
  children,
}: PropsWithChildren<AddressPlaceholderProps>): ReactNode {
  const { showPlaceholder } = usePlaceholders(
    addressType === 'merchant' ? PLACEHOLDERS.MerchantAddress : PLACEHOLDERS.ClientAddress
  );

  if (showPlaceholder) {
    return (
      <div className={styles.address}>
        <Placeholder width="109px" />
        <Placeholder width="77px" />
        <Placeholder width="137px" />
        <Placeholder width="90px" />
      </div>
    );
  }

  return <>{children}</>;
}
